import MaterialIcons from '@expo/vector-icons/MaterialIcons';
import { useRouter } from 'expo-router';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { IconButton } from 'ucl/components/icon-button/IconButton';
import Icon from 'ucl/components/icon/Icon';

import { ActionButtonSizes } from 'components/action-button/types';
import { LinkNoDecoration } from 'components/app-header/styled';
import { BkLogoRevamp } from 'components/logo/bk-logo-revamp';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { useAuthContext } from 'state/auth';
import { ModalAuthScreen, ModalAuthTrigger } from 'state/auth/types';
import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';
import { isIOS } from 'utils/environment';
import { routes } from 'utils/routing';

interface IWalmartHeaderV2 {
  disabled?: boolean;
}

export const WalmartHeaderV2 = ({ disabled = false }: IWalmartHeaderV2) => {
  const { top } = useSafeAreaInsets();
  const router = useRouter();
  const isMobile = useIsMobileBreakpoint();
  const { isAuthenticated, setModalAuthState } = useAuthContext();

  if (disabled) {
    return null;
  }

  const handleLogin = () =>
    setModalAuthState({
      screen: ModalAuthScreen.SIGN_IN,
      trigger: ModalAuthTrigger.Global,
    });

  return (
    <View
      style={{
        ...modalHeaderStyles.headerContainer,
        ...(isMobile && modalHeaderStyles.headerContainerMobile),
        marginTop: !isIOS ? top : 0,
      }}
    >
      <LinkNoDecoration
        style={modalHeaderStyles.logoContainer}
        onPress={() => router.replace(routes.base)}
      >
        <BkLogoRevamp />
      </LinkNoDecoration>
      <View style={[modalHeaderStyles.headerFlexEnd, !isAuthenticated && styles.headerActions]}>
        {!isAuthenticated && (
          <IconButton
            icon={<MaterialIcons name="person" size={24} color={primitive.$bbqBrown} />}
            size={ActionButtonSizes.SMALL}
            onPress={handleLogin}
            testID="header-login-button"
            accessible
            accessibilityRole="button"
            accessibilityLabel={t('signUpOrSignIn')}
            alignSelf="center"
          />
        )}
        <TouchableOpacity
          onPress={() => (router.canGoBack() ? router.back() : router.replace(routes.base))}
          testID="modal-back-button"
          hitSlop={15}
        >
          <Icon variant="cancel" />
        </TouchableOpacity>
      </View>
    </View>
  );
};

export const modalHeaderStyles = StyleSheet.create({
  headerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: spacing.$4,
  },
  headerContainerMobile: {
    justifyContent: 'flex-start',
    paddingLeft: spacing.$11,
  },
  logoContainer: {
    height: 56,
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerFlexEnd: {
    position: 'absolute',
    right: spacing.$4,
  },
});

const styles = StyleSheet.create({
  headerActions: {
    flexDirection: 'row',
    gap: spacing.$4,
  },
});
